export default __webpack_public_path__ + "static/media/NU.66e0b4db.ico";